<template>
	<c-modal @close="close" :title="'Bezorger wijzigen'">
		
		<c-form ref="form" @valid="submit" class="margin-t-40">

            <c-select
                :label="'Bezorger'"
                :horizontal="true"
                :options="carriers"
                :required="false"
                v-model="carrier"
                :name="'name'"
				:ValueName="'id'">
            </c-select>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Opslaan</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CModal from '@components/Modal';

import { mapState } from 'vuex';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
    props: {
        delivery: {
            required: false
        }
    },
	data() {
		return {
			carriers: [],
            carrier: ''
		}
	},
	methods: {
        load(){
            this.$xhr.get('/api/carriers').then( ({result}) => {
                this.carriers = result;
            }).catch( (e) => {

            });

            this.carrier = this.delivery.carrier_id;
        },
		submit() {

            let data = {
                carrier_id: this.carrier
            }

            data._method = 'PUT';
            this.$xhr.post('/api/deliveries/' + this.delivery.id, data).then( ( {result}) => {
                this.close();
                this.$emit('added');
                this.$store.dispatch('toast/success', {title: 'Bezorger aanpassen', text: 'De bezorger is aangepast'});
            }).catch( (e) => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.$store.dispatch('toast/alert', {title: 'Bezorger aanpassen', text: 'Er is helaas iets fout gegaan bij het aanpassen van de bezorger'});
            });
		},
		close() {
			this.$emit('close');
		},
	},
    mounted(){
        this.load();
    }
}
</script>